// scroll reveals
const io = new IntersectionObserver((es)=>{
  es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
},{threshold:.15});
document.querySelectorAll('.rev').forEach(el=>io.observe(el));

// rank ladder fill
const ladder = document.getElementById('ladder');
if(ladder){
  new IntersectionObserver((es,o)=>{
    es.forEach(e=>{ if(e.isIntersecting){ ladder.classList.add('lit'); o.disconnect(); } });
  },{threshold:.35}).observe(ladder);
}


// reviews carousel
(function(){
  const root=document.getElementById('revCarousel'); if(!root) return;
  const slides=[...root.querySelectorAll('.slide')], dots=[...root.querySelectorAll('.dot')];
  const stage=root.querySelector('.stage');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let i=0, timer=null;
  function size(){
    let h=0; slides.forEach(s=>{const was=s.classList.contains('on'); s.style.visibility='hidden'; s.style.position='relative'; s.style.opacity='0'; h=Math.max(h,s.offsetHeight); s.style.position=''; s.style.visibility=''; s.style.opacity=''; if(was) s.classList.add('on');});
    stage.style.minHeight=h+'px';
  }
  function go(n){
    i=(n+slides.length)%slides.length;
    slides.forEach((s,k)=>s.classList.toggle('on',k===i));
    dots.forEach((d,k)=>d.classList.toggle('on',k===i));
  }
  function play(){ if(reduce) return; stop(); timer=setInterval(()=>go(i+1),7000); }
  function stop(){ if(timer) clearInterval(timer); timer=null; }
  root.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{go(i+ +b.dataset.step); play();}));
  dots.forEach(d=>d.addEventListener('click',()=>{go(+d.dataset.go); play();}));
  root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',play);
  root.addEventListener('focusin',stop); root.addEventListener('focusout',play);
  let x0=null;
  stage.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
  stage.addEventListener('touchend',e=>{ if(x0===null) return; const dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>45){go(i+(dx<0?1:-1)); play();} x0=null; },{passive:true});
  window.addEventListener('resize',size);
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(()=>{size();}); }
  size(); play();
})();